<template>
  <div class="transfer-goods-manage-container">
    <ds-page-header :title="$t('transferGoodsManage.page.title')" :subtitle="$t('transferGoodsManage.page.subtitle')">
      <template #extra>
        <el-button size="small" icon="el-icon-back" @click="goBack">{{ $t('common.back') }}</el-button>
        <el-button type="primary" size="small" icon="el-icon-check" @click="finishStep">
          {{ $t('common.submit') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('transferGoodsManage.recipient') }}</span>
      </div>
      <el-form label-width="120px" class="ds-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('transferGoodsManage.recipient')">
              <el-input v-model="transferGoodsManageInfo.endUserInfo.staffName"
                :placeholder="$t('transferGoodsManage.requiredContact')" clearable />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('transferGoodsManage.selectRecipient')">
              <el-button type="primary" size="small" @click="chooseEndUser">
                <i class="el-icon-search"></i>
                {{ $t('transferGoodsManage.selectRecipient') }}
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('transferGoodsManage.transferDescription')">
              <el-input type="textarea" v-model="transferGoodsManageInfo.description"
                :placeholder="$t('transferGoodsManage.requiredDescription')" :rows="2" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="ds-panel">
      <ds-toolbar :show-column-setting="false" :show-density="false" :show-refresh="false">
        <template #left>
          <span class="ds-panel__title">{{ $t('transferGoodsManage.goodsInfo') }}</span>
        </template>
        <template #right>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="openSelectResourceStaffInfoModel">
            {{ $t('transferGoodsManage.selectGoods') }}
          </el-button>
        </template>
      </ds-toolbar>
      <ds-data-table :data="transferGoodsManageInfo.resourceStores" border
        :empty-description="$t('transferGoodsManage.page.empty')">
        <el-table-column prop="resName" :label="$t('transferGoodsManage.goodsName')" align="center" min-width="140" />
        <el-table-column prop="resCode" :label="$t('transferGoodsManage.goodsCode')" align="center" width="120">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.resCode || '-' }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('transferGoodsManage.goodsType')" align="center" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.parentRstName || '-' }} &gt; {{ scope.row.rstName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="isFixedName" :label="$t('transferGoodsManage.isFixedGoods')" align="center" width="110" />
        <el-table-column :label="$t('transferGoodsManage.goodsStock')" align="center" width="120">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.stock }}{{ scope.row.unitCodeName }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('transferGoodsManage.miniStock')" align="center" width="130">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.miniStock }}{{ scope.row.miniUnitCodeName }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('transferGoodsManage.transferQuantity')" align="center" min-width="160">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.giveQuantity" controls-position="right" style="width: 120px" :min="0" />
            {{ scope.row.miniUnitCodeName }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('transferGoodsManage.remark')" align="center" min-width="140">
          <template slot-scope="scope">
            <el-input v-model="scope.row.purchaseRemark" clearable />
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" align="center" width="90" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="removeSelectResourceStoreItem(scope.row.resId)">
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </ds-data-table>

      <ChooseResourceStaff ref="chooseResourceStaff" @setSelectResourceStores="setSelectResourceStores" />
    </div>

    <SelectStaff ref="selectStaff" @selectStaff="setEndUserInfo" />
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import ChooseResourceStaff from '@/components/resource/chooseResourceStaff'
import SelectStaff from '@/components/staff/SelectStaff'
import { getUserId } from '@/api/user/userApi'
import { saveAllocationUserStorehouse } from '@/api/resource/transferGoodsManageApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'TransferGoodsManageList',
  components: {
    ChooseResourceStaff,
    SelectStaff,
    DsPageHeader,
    DsToolbar,
    DsDataTable
  },
  data() {
    return {
      communityId: '',
      transferGoodsManageInfo: {
        description: '',
        endUserInfo: {
          staffId: '',
          staffName: '',
          staffTel: ''
        },
        resourceStores: []
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.initStep()
  },
  methods: {
    initStep() {
      this.transferGoodsManageInfo = {
        description: '',
        endUserInfo: {
          staffId: '',
          staffName: '',
          staffTel: ''
        },
        resourceStores: []
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    chooseEndUser() {
      this.$refs.selectStaff.open()
    },
    setEndUserInfo(staff) {
      this.transferGoodsManageInfo.endUserInfo = {
        staffId: staff.userId,
        staffName: staff.userName,
        staffTel: staff.tel
      }
    },
    openSelectResourceStaffInfoModel() {
      this.$refs.chooseResourceStaff.open()
    },
    setSelectResourceStores(resourceStores) {
      const oldList = this.transferGoodsManageInfo.resourceStores
      resourceStores.forEach(newItem => {
        newItem.quantity = 0
        oldList.forEach(oldItem => {
          if (oldItem.resId === newItem.resId) {
            newItem.giveQuantity = oldItem.giveQuantity
            newItem.price = oldItem.price
            newItem.purchaseRemark = oldItem.purchaseRemark
          }
        })
      })
      this.transferGoodsManageInfo.resourceStores = resourceStores
    },
    removeSelectResourceStoreItem(resId) {
      this.transferGoodsManageInfo.resourceStores = this.transferGoodsManageInfo.resourceStores.filter(
        item => item.resId !== resId
      )
    },
    async finishStep() {
      const postData = {
        resourceStores: this.transferGoodsManageInfo.resourceStores,
        description: this.transferGoodsManageInfo.description,
        file: '',
        acceptUserId: this.transferGoodsManageInfo.endUserInfo.staffId,
        acceptUserName: this.transferGoodsManageInfo.endUserInfo.staffName,
        communityId: this.communityId
      }
      const currentUserId = getUserId()
      if (currentUserId === postData.acceptUserId) {
        this.$message.error(this.$t('transferGoodsManage.cannotTransferToSelf'))
        return
      }
      if (!postData.acceptUserId) {
        this.$message.error(this.$t('transferGoodsManage.selectRecipientFirst'))
        return
      }
      if (!postData.description) {
        this.$message.error(this.$t('transferGoodsManage.fillDescriptionFirst'))
        return
      }
      const _resourceStores = postData.resourceStores
      if (_resourceStores.length <= 0) {
        this.$message.error(this.$t('transferGoodsManage.selectGoodsFirst'))
        return
      }
      for (let i = 0; i < _resourceStores.length; i++) {
        if (
          !Object.prototype.hasOwnProperty.call(_resourceStores[i], 'giveQuantity') ||
          parseFloat(_resourceStores[i].giveQuantity) <= 0
        ) {
          this.$message.error(this.$t('transferGoodsManage.fillQuantityFirst'))
          return
        }
        _resourceStores[i].giveQuantity = parseFloat(_resourceStores[i].giveQuantity)
        if (
          _resourceStores[i].giveQuantity >
          parseFloat(_resourceStores[i].miniStock)
        ) {
          this.$message.error(
            `${_resourceStores[i].resName},${this.$t('transferGoodsManage.insufficientStock')}`
          )
          return
        }
      }
      try {
        const res = await saveAllocationUserStorehouse(
          postData
        )
        if (res.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.$router.push('/resource/myResourceStoreManage')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(this.$t('common.operateFailed'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.transfer-goods-manage-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);
  &--padded { padding: var(--ds-spacing-lg); }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: var(--ds-spacing-md);
    margin-bottom: var(--ds-spacing-md);
    border-bottom: 1px solid var(--ds-gray-200);
  }
  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}
.ds-form {
  margin-top: var(--ds-spacing-sm);
}
</style>
